module.exports = __webpack_public_path__ + "img/bannerimg9.2e4eaedf.png";